import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSippsLevel,
  setSippsLesson,
  selectSippsLevel,
  selectSippsLesson
} from "../../../../slices/form";
import OptionsDropDown from "../../../UI/options_drop_down/options_drop_down";
import styles from "./questionTypes.module.css"; 

const SippsLevelLessonSelector = ({ advancedOnly=false }) => {
  const dispatch = useDispatch();
  const sippsLevel = useSelector(selectSippsLevel) ?? "beginning";
  const sippsLesson = useSelector(selectSippsLesson) ?? (advancedOnly ? 30 : 4);


  const sippsLevelOptions = [
    { name: "Beginning", value: "beginning" },
    { name: "Extension", value: "extension" },
    { name: "Challenge A (grade 2 listening vocab)", value: "challenge a" },
    { name: "Challenge B (grade 3 listening vocab)", value: "challenge b" },
    { name: "Challenge C (grade 4+ listening vocab)", value: "challenge c" },
  ];

  /* Get the list of lesson names that are valid for the selected SIPPS level. For advanced reading (our normal text generation tool)
     we only allow starting at lesson 30 (beginning) or Beginning review 10 (extension) */
  const sippsLessonOptions = () => {
    if (sippsLevel === "beginning") {
      if (advancedOnly) {
        return Array.from({ length: 26 }, (_, i) => ({ name: `${i + 30}`, value: i + 30 }));
      } else {
        return Array.from({ length: 52 }, (_, i) => ({ name: `${i + 4}`, value: i + 4 }));
      }
    } else if (sippsLevel === "extension") {
      if (advancedOnly) {
        return [
          ...Array.from({ length: 6 }, (_, i) => ({ name: `Beginning Review ${i + 10}`, value: `Beginning Review ${i + 10}` })),
          ...Array.from({ length: 40 }, (_, i) => ({ name: `${i + 1}`, value: i + 1 }))
        ];
      } else {
        return [
          ...Array.from({ length: 15 }, (_, i) => ({ name: `Beginning Review ${i + 1}`, value: `Beginning Review ${i + 1}` })),
          ...Array.from({ length: 40 }, (_, i) => ({ name: `${i + 1}`, value: i + 1 }))
        ];
      }
    } else if (typeof sippsLevel === "string" && sippsLevel.startsWith("challenge")) {
      return Array.from({ length: 75 }, (_, i) => ({ name: `${i + 1}`, value: i + 1 }));
    }
    return [];
  };

  const handleSippsLevelChange = (event) => {
    const selectedLevel = event.target.value;
    dispatch(setSippsLevel(selectedLevel));
    if (selectedLevel === "beginning") {
      dispatch(setSippsLesson(advancedOnly ? 30 : 4));
    } else if (selectedLevel === "extension") {
      dispatch(setSippsLesson(advancedOnly ? "Beginning Review 10" : "Beginning Review 1"));
    } else {
      dispatch(setSippsLesson(1));
    }
  };

  const handleSippsLessonChange = (event) => {
    dispatch(setSippsLesson(event.target.value));
  };

  return (
    <div className={styles.sippsLevelLessonSelector}>
      <div className={styles.mainSection}>
        <p className={styles.label} style={{ marginBottom: "0" }}>Select a level</p>
        <div className={styles.incrementDecrementContainer} style={{ marginTop: "0" }}>
          <OptionsDropDown
            name="sippsLevel"
            onChangeHandler={handleSippsLevelChange}
            options={sippsLevelOptions}
            isDisabled={false}
            isRequired={true}
            value={sippsLevel || ""}
          />
        </div>
      </div>
      <div className={styles.mainSection}>
        <p className={styles.label} style={{ marginBottom: "0" }}>Select a lesson</p>
        <div className={styles.incrementDecrementContainer} style={{ marginTop: "0" }}>
          <OptionsDropDown
            name="sippsLesson"
            onChangeHandler={handleSippsLessonChange}
            options={sippsLessonOptions()}
            isDisabled={false}
            isRequired={true}
            value={sippsLesson || ""}
          />
        </div>
      </div>
    </div>
  );
};

export default SippsLevelLessonSelector;
